import React from 'react';
import styled from 'styled-components';

//#region Styled Components
const SelectContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  border: 1px solid var(--border-main);
  border-radius: 0.25em;
  padding: 0.25em 0.5em;
  font-size: 1.25rem;
  cursor: pointer;
  display: grid;
  grid-template-areas: 'select';
  align-items: center;
  transition: border-color 0.15s ease;
  position: relative;

  &:after {
    content: '';
    width: 0.7em;
    height: 0.4em;
    background-color: var(--border-hover);
    clip-path: polygon(100% 0%, 0 0%, 50% 100%);
    grid-area: select;
    justify-self: end;
  }

  &:hover,
  &:focus,
  &:active {
    border-color: var(--border-hover);
  }
`;

const StyledSelect = styled.select`
  appearance: none;
  background-color: transparent;
  border: none;
  padding: 0 1em 0 0;
  margin: 0;
  width: 100%;
  font-family: inherit;
  font-size: 0.75rem;
  cursor: inherit;
  line-height: inherit;
  outline: none;
  grid-area: select;

  &:focus + .focus {
    position: absolute;
    top: -1px;
    left: -1px;
    right: -1px;
    bottom: -1px;
    border: 1px solid var(--border-hover);
    border-radius: inherit;
  }
`;
//#endregion

const Select = ({ children, className, onChange, tabIndex, value }) => {
  return (
    <SelectContainer className={className}>
      <StyledSelect tabIndex={tabIndex} onChange={onChange} value={value}>
        {children}
      </StyledSelect>
      <span className="focus" />
    </SelectContainer>
  );
};

export default Select;
